import * as R from "ramda";
import React, {Component, Fragment} from "react";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleDDL from "../../../../../modules/SimpleDDL";

class HeaderInputModifying extends Component {
    render() {
        return (
            <Fragment>
                <div style={{marginBottom: "50px"}}>
                    <div className="grid grid-2x gap-20px grid-mobile-none">
                        <div id="grid-1">
                            <SimpleInput
                                id="input_text_submission_number"
                                name="handOverNumber"
                                label="No. Penyerahan"
                                readOnly
                                value={this.props.controls.handOverNumber.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_submission_date"
                                name="periodHandOver"
                                label="Tanggal Penyerahan"
                                readOnly
                                value={this.props.controls.periodHandOver.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            {
                                R.equals(this.props.action, "view")
                                    ?
                                    <SimpleInput
                                        id="input_text_leasing_name"
                                        name="leasingId"
                                        label="Nama Leasing"
                                        readOnly
                                        value={this.props.controls.leasingId.value?.label}
                                    />
                                    :
                                    <SimpleDDL
                                        id="select_options_leasing_name"
                                        box="search"
                                        name="leasingId"
                                        label="Nama Leasing"
                                        isClearable={true}
                                        mandatory
                                        errorMessage={this.props.errors.leasingId}
                                        options={this.props.dataLeasing}
                                        value={this.props.controls.leasingId.value}
                                        onChange={(value, {name}) => this.props.changeLeasing(name, value)}
                                    />
                            }

                        </div>
                        <div id="grid-2">
                            <SimpleInput
                                id="input_text_receipt_name"
                                name="receiptName"
                                label="Nama Penerima"
                                mandatory
                                readOnly={R.equals(this.props.action, "view")}
                                errorMessage={this.props.errors.receiptName}
                                value={this.props.controls.receiptName.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_phone_number"
                                name="contactNumber"
                                label="No HP"
                                box="onlyNumber"
                                mandatory
                                readOnly={R.equals(this.props.action, "view")}
                                errorMessage={this.props.errors.contactNumber}
                                value={this.props.controls.contactNumber.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_position"
                                name="jabatan"
                                label="Jabatan"
                                mandatory
                                readOnly={R.equals(this.props.action, "view")}
                                errorMessage={this.props.errors.jabatan}
                                value={this.props.controls.jabatan.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_employee_id"
                                name="idPegawai"
                                label="ID Pegawai"
                                mandatory
                                readOnly={R.equals(this.props.action, "view")}
                                errorMessage={this.props.errors.idPegawai}
                                value={this.props.controls.idPegawai.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default HeaderInputModifying;